import React from 'react';
import { Table, Badge } from 'antd';
import { Percentage } from "../../../utils/formatters";
import Dot from "../../../Components/Dot";
import {CaretUpOutlined} from "@ant-design/icons";
import {ArrowUpwardRounded, ArrowOutwardSharp} from "@mui/icons-material";

/**
 *
 * @param tickerList {Array[Object]} - An array of objects with properties {symbol: string, wgt: number, _missing: boolean, sector: string, ...}
 * @param selectedTickers {Array[Object] | optional} - An array of objects with properties
 *         {
 *            symbol: string, wgt: number, _missing: boolean, sector: string, ...
 *         }
 * @param isSelected {boolean | optional} - A boolean to indicate if the table is selected
 * @returns {JSX.Element}
 * @constructor
 */
const PositionTable = ({ tickerList, sectorColors, selectedTickers = [], isSelected=false }) => {
  let cumulativeWeight = 0;
  let threshold50Reached = false;
  let threshold75Reached = false;
  let threshold90Reached = false;

  const dataSource = tickerList.map((ticker, index) => {
    cumulativeWeight += ticker.wgt;
    let badgeText = null;

    if (!threshold50Reached && cumulativeWeight >= 0.50) {
      threshold50Reached = true;
      badgeText = '50%';
    } else if (!threshold75Reached && cumulativeWeight >= 0.75) {
      threshold75Reached = true;
      badgeText = '75%';
    } else if (!threshold90Reached && cumulativeWeight >= 0.90) {
      threshold90Reached = true;
      badgeText = '90%';
    }

    return {
      key: ticker.symbol,
      number: index + 1,
      name: ticker._missing ? `${ticker.symbol}` : ticker.symbol,
      weight: <Percentage value={ticker.wgt} />,
      cumulativeWeight: <Percentage value={cumulativeWeight} />,
      badgeStatus: badgeText,
      isHighlighted: selectedTickers.some(selected => selected.symbol === ticker.symbol),
      sector: ticker.sector,
    };
  });

  const columns = [
    {
      title: '',
      dataIndex: 'number',
      key: 'number',
      width: 50,
      render: (text, record) => {
        // Replace number with badge for specific rows
        if (record.badgeStatus) {
          return <Badge count={record.badgeStatus} style={{ backgroundColor: '#52c41a' }} />;
        }
        return <Dot color={sectorColors[record.sector]} icon={'fa-location-dot'} label={text} />;
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      className: 'hyper px-3',
      render: (text) => (
          <>
            {text.toUpperCase()}
            <sup><ArrowOutwardSharp sx={{fontSize: 8}}/></sup>
          </>
      )
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Total',
      dataIndex: 'cumulativeWeight',
      key: 'cumulativeWeight',

    },
  ];

  const getRowClassName = (record) => {
    return record.isHighlighted && !isSelected ? 'flag--danger' : '';
  };

  return (
    <Table
      className={`med`}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      scroll={{ y: 500 }}
      rowClassName={getRowClassName}
    />
  );
};

export default PositionTable;
